/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Skillcount1Inputs */

const en_entity_skillcount1 = /** @type {(inputs: Entity_Skillcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Count`)
};

const de_entity_skillcount1 = /** @type {(inputs: Entity_Skillcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skills`)
};

/**
* | output |
* | --- |
* | "Skill Count" |
*
* @param {Entity_Skillcount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_skillcount1 = /** @type {((inputs?: Entity_Skillcount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Skillcount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_skillcount1(inputs)
	return de_entity_skillcount1(inputs)
});
export { entity_skillcount1 as "entity_skillCount" }